/* eslint-disable */
import React from 'react';
import { ReferenceField, TextField, useTranslate } from 'react-admin';
import CustomReportTable from '../../../../base/components/reports/CustomReportTable';
import resourceSlug, { REPORT_TYPES } from '../../../../constant/resource-slug';
import { LIST_REPORTS } from '../../report-game-performance.list';
import TranslatableField from '../../../../base/components/ra/fields/translatable.field';

const OverallTable = () => {
  const translate = useTranslate();
  return (
    <CustomReportTable
      title={translate('resources.report.overall')}
      resource={resourceSlug.REPORT_GAME_PERFORMANCE}
      reportList={LIST_REPORTS}
      reportType={REPORT_TYPES.OVERALL}
    >
      <ReferenceField link="show" source="gameId" reference="game" label="resources.game.fields.gameId">
        <TextField source="gameId" />
      </ReferenceField>
      <ReferenceField source="group" reference="group" label="resources.group.name" link="show">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="brand" reference="brand" label="resources.brand.name" link="show">
        <TextField source="name" />
      </ReferenceField>
      <TranslatableField label="resources.report.fields.gameName" source="game" />
      <TextField label="resources.report.fields.currencyType" source="currencyType" sortable={false} />
      <ReferenceField link="show" source="currency" reference="currency" label="resources.currency.name">
        <TextField source="code" />
      </ReferenceField>
      <TextField label="resources.report.fields.betAmount" source="betAmount" sortable />
      <TextField label="resources.report.fields.wonAmount" source="wonAmount" sortable />
      <TextField source="date" label="resources.report.fields.date" sortable />
    </CustomReportTable>
  );
};

export default OverallTable;
